/** ISO-дата (yyyy-MM-dd) → русский формат dd.MM.yyyy. Без зависимости от локали устройства. */
export const formatRuDate = (iso: string | null | undefined): string => {
  const value = (iso ?? '').trim()
  if (!value) {
    return ''
  }
  const [year, month, day] = value.split('-')
  if (!year || !month || !day) {
    return value
  }
  return `${day}.${month}.${year}`
}
